import { Button, Typography } from "matsuri-ui"
import { css } from "@emotion/react"
import CloseIcon from "@mui/icons-material/Close"
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded"
import DeleteSweepRoundedIcon from "@mui/icons-material/DeleteSweepRounded"
import { Content, DoneBody, DoneIcon, InstructionBanner, Main } from "./styled"
import { MobileLayout } from "./utils"
import { Header } from "@/components/Header/Header"
import { MobileAppHeader } from "@/components/Header/MobileAppHeader"
import { ReportFooter } from "@/components/Footer/ReportFooter"
import { useTranslation } from "@/hooks/useTranslation"

interface Props {
    layout: MobileLayout
    onBack: () => void
    onDone: () => void
    onClose: () => void
}

/**
 * 廃棄物の指示画面。報告レコードは作らず、廃棄してもらうだけ。
 */
export const DisposalView = ({ layout, onBack, onDone, onClose }: Props) => {
    const { t } = useTranslation()

    return (
        <Main style={layout.rootProps.style}>
            <Header {...layout.headerProps}>
                <MobileAppHeader
                    title={
                        <Typography variant="h4">{t("廃棄の指示")}</Typography>
                    }
                    onPrev={onBack}
                    onNext={onClose}
                    nextIcon={<CloseIcon />}
                />
            </Header>

            <div {...layout.bodyProps}>
                <DoneBody>
                    <DoneIcon>
                        <DeleteSweepRoundedIcon style={{ fontSize: 44 }} />
                    </DoneIcon>
                    <Typography variant="h4" bolder>
                        {t("そのまま廃棄してください")}
                    </Typography>
                    <Typography color="textSecondary">
                        {t("この物品の報告は不要です。")}
                    </Typography>
                </DoneBody>

                <Content>
                    <InstructionBanner>
                        <AssignmentRoundedIcon style={{ fontSize: 20 }} />
                        <span>
                            {t(
                                "迷った場合は廃棄せず、戻って忘れ物として報告してください。"
                            )}
                        </span>
                    </InstructionBanner>
                </Content>
            </div>

            <ReportFooter {...layout.footerProps}>
                <Button
                    variant="filled"
                    color="primary"
                    fullWidth
                    onClick={onDone}
                >
                    {t("廃棄しました")}
                </Button>
                <Button
                    variant="outlined"
                    fullWidth
                    onClick={onBack}
                    css={css`
                        margin-top: 8px;
                    `}
                >
                    {t("戻る")}
                </Button>
            </ReportFooter>
        </Main>
    )
}
